/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select, Input } from 'antd';

const FILL_METHODS = ['Specific Value', 'Mean', 'Median', 'Mode'];

const FillMissingValuesForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={{ fillMethod: 'Specific Value', ...config }} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="Fill Method" name="fillMethod" rules={[{ required: true }]}>
            <Select options={FILL_METHODS.map(m => ({ label: m, value: m }))} />
        </Form.Item>
        <Form.Item label="Fill Value" name="fillValue">
            <Input placeholder="Enter fill value" />
        </Form.Item>
    </Form>
);

export default FillMissingValuesForm;
